import PropTypes from 'prop-types';
import React from 'react';
import api from '../../../Api';
import { connectToUser } from '../../User/containers/UserDataStore';
import makeConnectTo from '../../util/makeConnectTo';
import DownloadType from '../DownloadType';

const DownloadsContext = React.createContext();

const name = 'downloadsDataStore';

export const useDownloads = () => React.useContext(DownloadsContext);

export const connectToDownloads = makeConnectTo(DownloadsContext, name);

class DownloadsDataStore extends React.Component {
	static propTypes = {
		children: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
	};

	state = {
		downloads: [],
		selectedMenuOption: DownloadType.All.key,
		isLoading: true,
	};

	render() {
		const downloadsDataStore = this.getStore();
		return (
			<DownloadsContext.Provider value={downloadsDataStore}>
				{typeof this.props.children === 'function'
					? this.props.children(downloadsDataStore)
					: this.props.children}
			</DownloadsContext.Provider>
		);
	}

	componentDidMount() {
		const { isAnonymous } = this.props.userDataStore;
		if (!isAnonymous()) {
			this.fetchDownloads();
		} else {
			this.setState({ isLoading: false });
		}
	}

	componentWillUnmount() {
		if (this.downloadsFetch && this.downloadsFetch.cancel) {
			this.downloadsFetch.cancel();
		}
	}

	getStore = (state = this.state) => ({
		state,
		refresh: () => this.refreshDownloads(),
		setSelectedMenuOption: selectedMenuOption =>
			this.setSelectedMenuOption(selectedMenuOption),
	});

	refreshDownloads = () => {
		this.setState({
			isLoading: true,
		});
		this.fetchDownloads();
		return this.downloadsFetch.promise;
	};

	fetchDownloads = () => {
		const request = api.cancelableGet(`/api/v1/me/galleys/downloads`);
		request.promise
			.then(this.cacheApiResponse)
			.catch(e => console.error(e));
		this.downloadsFetch = request;
	};

	cacheApiResponse = apiResponse => {
		const downloads = apiResponse && this.getDownloads(apiResponse);
		this.setState({ downloads, isLoading: false });
	};

	getDownloads = apiResponse => {
		const {
			downloads,
			products,
			digitalCopyInfo,
			downloadableSkus,
			requestableSkus,
			cancelledSkus,
			userCommunitySummaryReviews,
		} = apiResponse;
		if (!downloads) {
			return [];
		}

		return downloads.map(download => {
			const availableReviewCopyFormats = digitalCopyInfo.filter(
				dci => dci.sku === download.sku,
			);
			const product =
				products && products.filter(pr => pr.sku === download.sku)[0];
			const isRequestable =
				requestableSkus &&
				requestableSkus.filter(rs => rs === download.sku)[0];
			const isDownloadable =
				downloadableSkus &&
				downloadableSkus.filter(dl => dl === download.sku)[0];
			const isCancelled =
				cancelledSkus &&
				cancelledSkus.filter(cs => cs === download.sku)[0];
			product.digitalUpdatedDate =
				availableReviewCopyFormats &&
				availableReviewCopyFormats.length > 0 &&
				availableReviewCopyFormats[0].updatedDate;
			product.reviewCopyAvailability = isDownloadable
				? 'Available for Download'
				: isRequestable
				? 'Available for Request'
				: 'Review Copy Not Available';
			const csr =
				userCommunitySummaryReviews &&
				userCommunitySummaryReviews.filter(
					csr => csr.sku === product.sku,
				);
			var reviews = 0;
			var average = 0;
			if (csr && csr.length > 0) {
				reviews = csr[0].count;
				average = csr[0].rating && csr[0].rating.toFixed(1);
			}
			product.reviews = reviews;
			product.average = average;
			return {
				...download,
				product,
				isRequestable,
				isDownloadable,
				isCancelled,
				availableReviewCopyFormats,
				uri:
					product &&
					product.images &&
					product.images.filter(im => im.type === 'jacketCover')
						.length > 0 &&
					product.images.filter(im => im.type === 'jacketCover')[0]
						.uri + '?height=450',
			};
		});
	};

	setSelectedMenuOption = selectedMenuOption => {
		this.setState({ selectedMenuOption });
	};
}

export default connectToUser(DownloadsDataStore);
